export default __webpack_public_path__ + "39b47c4536b8a0573b2fba277f75ecb6.png";